<template>
    <div class="full-image">
        <div class="bg" @click="closeFullImage()">x</div>
        <div class="window">
            <div class="prev-flower" @click="prev">-</div>
            <div class="image">
                <div class="image-block">
                    <div class="my-close-btn" @click="closeModal"></div>
                    <div class="original_open">
                        <div v-if="watermark" class="watermark">
                            <img src="/local-images/water_mark.jpg" alt="">
                        </div>
                        <img :src="img" alt="current">
                    </div>

                </div>
                <p v-if="name" class="name">{{name}}</p>
            </div>
            <div class="next-flower" @click="next">+</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'gallery-modal',
        props: {
            img: {
                required: true,
            },
            name: {
                required: false,
            },
            watermark: {
                required: false,
            },
        },
        methods: {
            closeModal() {
                this.$emit('close');
            },
            prev() {
                this.$emit('prev');
            },
            next() {
                this.$emit('next');
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/components/elements/GalleryModal.vue